import { createContext, useState } from "react";

export const EmpresasContext = createContext();

export const EmpresasProvider = ({ children }) => {
    const [empresas, setEmpresas] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [editedCompanyId, setEditedCompanyId] = useState(null);
    const [formData, setFormData] = useState({ nome: "", descricao_negocio: "" }); // Estado que armazena o Objeto Formulário para a criação de empresas

    return (
        <EmpresasContext.Provider value={{ empresas, setEmpresas, isEditing, setIsEditing, editedCompanyId, setEditedCompanyId, formData, setFormData }}>
            {children}
        </EmpresasContext.Provider>
    );
};